// src/api/dip.js
// -----------------------------------------------------------------------------
// API pour l'agent DIP (via Xano qui appelle Dify)
// -----------------------------------------------------------------------------
import { api } from "../lib/apiClient";

/**
 * POST /ciaov2_dip_chat
 * Envoie un message à DIP et reçoit la réponse
 * Xano se charge d'appeler Dify et d'enregistrer les messages
 */
export async function sendDifyMessage(message, conversation_id, bot_id, authToken) {
  const { data } = await api.post(
    `/ciaov2_dify_chat_message/${conversation_id}`,
    { message, bot_id },
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
  // Retourne: { answer, conversation_id, message_id, user_message, bot_message }
}
